import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip_Finding_Base } from './Tooltip_Finding_Base.js';
import { _className, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Tooltip_Finding_Numeric.scss';
export class Tooltip_Finding_Numeric extends Tooltip_Finding_Base {
    //######################### Render #########################
    render_Content = () => {
        return _jsxs(_Fragment, { children: [this.render_Units(), this.render_NormalRange(), this.render_Source(), this.render_Divider(), _jsx(LL_V_L, { className: 'finding-tooltip__content enum', children: this.render_Samples() })] });
    };
    //######################### Render - Sample #########################
    render_Samples = () => {
        return _jsxs(LL_V_L, { className: 'numeric-results', children: [_jsx("div", { className: 'numeric-results__section-title', children: "Samples:" }), this.state.data.results?.map(this.render_Sample)] });
    };
    render_Sample = (result, index) => {
        const timestamp = this.resolveTimestamp(result);
        const value = this.resolveValue(result);
        const className = _className('numeric-result', !result.currentEncounter && 'prev-encounter', this.isAbnormal(result) && 'abnormal');
        return _jsxs(LL_H_C, { className: className, children: [_jsx("div", { className: 'numeric-result__value', children: value }), _jsx("div", { className: 'numeric-result__timestamp', children: timestamp })] }, index);
    };
}
//# sourceMappingURL=Tooltip_Finding_Numeric.js.map